"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.screen_bar_chart = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const screen_bar_chart = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'screen-bar-chart-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M9.25 13L9.25 7H10.75V13H9.25Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12.25 13V8H13.75V13H12.25Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6.25 13V9H7.75V13H6.25Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3.5 4.5V15.5H16.5V4.5H3.5ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3Z', fill: '#4B5563' })));
};
exports.screen_bar_chart = screen_bar_chart;
